import { render } from "./MyExpresswayLogo.vue?vue&type=template&id=5c3b1042"
const script = {}
script.render = render

export default script